import { render } from "./submitResult.vue?vue&type=template&id=f55938aa&scoped=true"
import script from "./submitResult.vue?vue&type=script&lang=js"
export * from "./submitResult.vue?vue&type=script&lang=js"

import "./submitResult.vue?vue&type=style&index=0&id=f55938aa&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_FAnl/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55938aa"]])

export default __exports__